import styled from '@emotion/styled'
import { ConfigurationContext, WebLink } from '@news-mono/web-common'
import React, { useContext } from 'react'
import { IconDownloadAppStore, IconDownloadPlayStore } from '../../../icons'
import { calcRem } from '../../../__styling'

export const StyledWebLink = styled(WebLink)({
    display: 'block',
    height: calcRem(48),

    img: {
        height: '100%',
    },
})

export function TNAppDownloadButtons() {
    const config = useContext(ConfigurationContext)

    return (
        <>
            <StyledWebLink to={config.appDownloadUrlApple ?? '#'}>
                <IconDownloadAppStore />
            </StyledWebLink>
            <StyledWebLink to={config.appDownloadUrlGoogle ?? '#'}>
                <IconDownloadPlayStore />
            </StyledWebLink>
        </>
    )
}
